﻿
export function useTemplateConfig(useGlobalConfig = false) {
  return {
    isGlobal: useGlobalConfig,
    canEditGlobal: useGlobalConfig,
    useGlobalEndpoint: useGlobalConfig,
    requiredAction: useGlobalConfig ? "Internal" : "Checks:TemplateBuilder",
    title: useGlobalConfig ? "Checks Standard Templates" : "Checks Templates",
    baseRoute: useGlobalConfig ? "/checks/standard-templates" : "/checks/templates",
  };
}